goog.provide("shadow.js.shim.module$$mui$material$Tabs$default");
shadow.js.shim.module$$mui$material$Tabs$default = shadow.js.shim.module$$mui$material$Tabs.default;
